import React from 'react';

let PopularServiceRow = class extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { service } = this.props;
        return (
            <tbody>
                <tr>
                    <td>{service.Rate}</td>
                    <td>{service.Name}</td>
                    <td>{service.Amount}</td>
                    <td>{service.Sum}</td>
                </tr>
            </tbody>);
    }
}

export default PopularServiceRow;


// WEBPACK FOOTER //
// ./src/components/analytics/popularServices/PopularServiceRow.jsx